export default __webpack_public_path__ + "static/media/ban-member.f569c120.svg";